module.exports = __webpack_public_path__ + "img/19.5866c3c9.png";